import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ApiService from 'redux/services/api-service';
import {addResultCases} from 'utils/helpers';
import {ListResult, SingleResult} from 'utils/types';

export interface EmailTemplate {
  id: number;
  name: string;
  description: string;
  is_active: boolean;
}

export interface EmailTemplateRenderedResponse {
  rendered_text: string;
  template_name: string;
  template_description: string;
  campaign_name: string;
  retailers: string[];
  start_date: string | null;
  end_date: string | null;
  has_missing_data: boolean;
}

export interface RenderEmailTemplateRequest {
  template_id: number;
  campaign_id: number;
  locale?: string;
  include_missing_data_section?: boolean;
}

export interface IState {
  emailTemplates: ListResult<EmailTemplate[]>;
  renderedTemplate: SingleResult<EmailTemplateRenderedResponse>;
}

export const emailTemplateEndpoints = {
  getEmailTemplates: createAsyncThunk('emailTemplate/getEmailTemplates', async () => {
    const response = await ApiService.get('/email_templates/');
    return response.data;
  }),
  renderEmailTemplate: createAsyncThunk(
    'emailTemplate/renderEmailTemplate',
    async (data: RenderEmailTemplateRequest) => {
      const response = await ApiService.post('/email_templates/render/', data);
      return response.data;
    },
  ),
};

export const emailTemplateSlice = createSlice({
  name: 'emailTemplate',
  initialState: {
    emailTemplates: {as: 'idle'},
    renderedTemplate: {as: 'idle'},
  } as IState,
  reducers: {
    clearRenderedTemplate: state => {
      state.renderedTemplate = {as: 'idle'};
    },
  },
  extraReducers: builder => {
    addResultCases(builder, emailTemplateEndpoints.getEmailTemplates, 'emailTemplates');
    addResultCases(builder, emailTemplateEndpoints.renderEmailTemplate, 'renderedTemplate');
  },
});

export const {clearRenderedTemplate} = emailTemplateSlice.actions;

export type EmailTemplateSlice = {
  [emailTemplateSlice.name]: ReturnType<(typeof emailTemplateSlice)['reducer']>;
};
